import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { AppUrls } from '../utility/appurls';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private identityService = inject(IdentityService);
  private router = inject(Router);

  
 

  

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.identityService.isLoggedIn()) {
      return this.identityService.authenticateUser(state.url).pipe(
        map(e => !!e),
        catchError(() => of(false)),
      );
    } else {
      const expectedPermissions: string[] = route.data.permissions;
      if (expectedPermissions === undefined || expectedPermissions == null) {
        return true; // Anonymous route - Okay
      }

      for (const expectedPermission of expectedPermissions) {
        if (this.identityService.hasPermissions(expectedPermission)) {
          return true; // Permission match - Okay
        }
      }

      // No matching permissions - Redirect to unauthorized
      this.router.navigate([AppUrls.unauthorized()], { skipLocationChange: true });
      return false;
    }
  }
}
